import { Dispatch } from 'redux';
import { LoginService } from '../../services/LoginService';
 import { Admin_API, SUPRIVISOR_API } from '../../ApiNames';


export const fetchDoc = (doctordetails: any) => ({
    type: 'FETCH_DOCT_SUCCESS',
    payload: doctordetails,
});
export const fetchAss = (assistantsdetails: any) => ({
    type: 'FETCH_ASS_SUCCESS',
    payload: assistantsdetails,
});
export const fetchLin = (linkassistantsdetails: any) => ({
    type: 'FETCH_LINKASS_SUCCESS',
    payload: linkassistantsdetails,
});


export const fetchDocDetails = (uid:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {q:1,userid:uid};
            const apiname = SUPRIVISOR_API.sreports;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchDoc(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};
export const fetchAssistantDetails = (uid:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {userid:uid,q:2};
            const apiname = SUPRIVISOR_API.sreports;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchAss(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};
export const fetchLinkAssistantsDetails = (uid:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {q:3,userid:uid};
            const apiname = SUPRIVISOR_API.sreports;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchLin(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};
